import { render, staticRenderFns } from "./data-table-row.component.vue?vue&type=template&id=21e33e74&scoped=true"
import script from "./data-table-row.component.vue?vue&type=script&lang=ts"
export * from "./data-table-row.component.vue?vue&type=script&lang=ts"
import style0 from "./data-table-row.component.vue?vue&type=style&index=0&id=21e33e74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e33e74",
  null
  
)

export default component.exports